export default __webpack_public_path__ + "static/media/retro2.13e443d9.jpg";